import { useToast } from '@bv/composables/common/toast';
import { useUserStore } from '@bv/stores/user';
import { defineStore } from 'pinia';

import userDetails from '@/api/auth/user-details.api';
import { setItem } from '@/shared/helpers/cookies/cookies';

const toast = useToast();

export const userDetailsStore = defineStore('UserDetails', {
  state: () => ({
    userData: null,
    userRoles: {},
    currentWorkspace: null,
    uiFlags: {
      isFetching: false,
      isSubmitting: false,
    },
  }),
  getters: {
    getUserRoles(state) {
      return state.userRoles;
    },
    getUserData(state) {
      return state.userData;
    },
    getWorkspaces(state) {
      return state.userData?.workspaces;
    },
  },
  actions: {
    async getUserDataRequest(fetchUpdated = false) {
      if (!fetchUpdated && this.userData) {
        return;
      }

      this.uiFlags.isFetching = true;
      try {
        const data = await useUserStore().getUserDetails();
        this.userData = data;

        this.setCurrentWorkspace();
      } finally {
        this.uiFlags.isFetching = false;
      }
    },
    setCurrentWorkspace() {
      let workspaceId =
        this.userData.recent_workspaces[this.userData.recent_service] || this.userData?.workspaces[0].id;
      this.currentWorkspace = this.userData.workspaces.find((workspace) => workspace.id == workspaceId);
      setItem('x-workspace-id', workspaceId);
    },
    async hasPermissions(permission) {
      const permissions = Array.isArray(permission) ? permission : permission ? [permission] : [];

      await this.getUserDataRequest();

      const validPermissions = permissions.filter((value) => this.userData.role.permissions.includes(value));

      return validPermissions.length === permissions.length;
    },
    resetUserData() {
      this.userData = {};
      this.currentWorkspace = null;
    },
    async updateUserCredential(data) {
      this.uiFlags.isSubmitting = true;
      return userDetails
        .create(data, 'users/profile/update')
        .then(() => {
          useUserStore().getUserDetails({ forceUpdate: true });
          toast.success('User data update');
        })
        .catch((error) => {
          throw new Error(error);
        })
        .finally(() => {
          this.uiFlags.isSubmitting = false;
        });
    },
  },
});
